import React, { useState } from "react";
import Navbar from "../../components/Navbar";

import BilleteraOverview from "../../components/BillateraOverview";

function MovimientosBilleteras() {
  const [data, setData] = useState();

  return (
    <div>
      <div className="container">
        <Navbar />
        <BilleteraOverview />
      </div>
    </div>
  );
}

export default MovimientosBilleteras;
